import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f9fafb;
}`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];
    public summary: any = {
        total: 0,
        admin: 0,
        manager: 0,
        reviewer: 0,
        viewer: 0,
        active: 0,
        inactive: 0,
        locked: 0,
        inactive_locked: 0,
    };

    public search: any = {
        text: "",
        role: "",
        status: "",
    };

    public roleOptions: any[] = [
        { key: "admin", label: "시스템관리자" },
        { key: "manager", label: "관리자" },
        { key: "reviewer", label: "검수자" },
        { key: "viewer", label: "조회자" },
    ];

    public statusOptions: any[] = [
        { key: "active", label: "활성" },
        { key: "inactive", label: "비활성" },
        { key: "locked", label: "잠김" },
    ];

    public showInviteModal: boolean = false;
    public inviteData: any = { email: "", role: "viewer" };
    public selectedMember: any = null;
    public detailRole: string = "viewer";

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list", this.search);
        if (code === 200) {
            if (Array.isArray(data)) {
                this.members = data || [];
                this.summary = this.localSummary(this.members);
            } else {
                this.members = data?.members || [];
                this.summary = data?.summary || this.localSummary(this.members);
            }
        }

        this.loading = false;
        await this.service.render();
    }

    private localSummary(members: any[]) {
        const rows = members || [];
        const count = (fn: any) => rows.filter(fn).length;
        const inactive = count((item: any) => item.status === "inactive");
        const locked = count((item: any) => item.status === "locked");
        return {
            total: rows.length,
            admin: count((item: any) => ["admin", "system"].includes(item.role)),
            manager: count((item: any) => item.role === "manager"),
            reviewer: count((item: any) => item.role === "reviewer"),
            viewer: count((item: any) => item.role === "viewer"),
            active: count((item: any) => item.status === "active"),
            inactive,
            locked,
            inactive_locked: inactive + locked,
        };
    }

    public get summaryCards() {
        return [
            { key: "total", label: "전체 사용자", value: this.summary.total || 0, sub: "등록 계정", tone: "total" },
            { key: "admin", label: "시스템관리자", value: this.summary.admin || 0, sub: "운영 권한", tone: "admin" },
            { key: "manager", label: "관리자", value: this.summary.manager || 0, sub: "자료 관리", tone: "manager" },
            { key: "reviewer", label: "검수자", value: this.summary.reviewer || 0, sub: "QA 검수", tone: "reviewer" },
            { key: "risk", label: "비활성/잠김", value: this.summary.inactive_locked || 0, sub: `비활성 ${this.summary.inactive || 0} · 잠김 ${this.summary.locked || 0}`, tone: "risk" },
        ];
    }

    public async setRole(role: string) {
        this.search.role = this.search.role === role ? "" : role;
        await this.load();
    }

    public async resetFilters() {
        this.search = { text: "", role: "", status: "" };
        await this.load();
    }

    public hasFilters() {
        return !!(this.search.text || this.search.role || this.search.status);
    }

    public async openInvite() {
        this.inviteData = { email: "", role: "viewer" };
        this.showInviteModal = true;
        await this.service.render();
    }

    public async closeInvite() {
        this.showInviteModal = false;
        await this.service.render();
    }

    public async invite() {
        if (!this.inviteData.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }

        const { code, data } = await wiz.call("invite", this.inviteData);
        if (code === 200) {
            await this.service.modal.success("초대가 완료되었습니다.");
            this.showInviteModal = false;
            await this.load();
        } else {
            await this.service.modal.error(data?.message || "초대에 실패했습니다.");
        }
    }

    public async openDetail(member: any) {
        this.selectedMember = member;
        this.detailRole = member?.role || "viewer";
        await this.service.render();
    }

    public async closeDetail() {
        this.selectedMember = null;
        await this.service.render();
    }

    public canEditSelectedRole() {
        return !!this.selectedMember && this.selectedMember.role !== "system" && !this.isSelf(this.selectedMember);
    }

    public canRemoveSelected() {
        return !!this.selectedMember && this.selectedMember.role !== "system" && !this.isSelf(this.selectedMember);
    }

    public isSelf(member: any) {
        const currentId = String(this.service.auth.session?.id || this.service.auth.session?.user_id || "");
        return !!member?.id && String(member.id) === currentId;
    }

    public async saveRole() {
        if (!this.selectedMember) return;
        if (!this.canEditSelectedRole()) {
            await this.service.modal.error("이 계정의 권한은 여기서 변경할 수 없습니다.");
            return;
        }

        const { code, data } = await wiz.call("update_role", {
            id: this.selectedMember.id,
            role: this.detailRole,
        });
        if (code === 200) {
            await this.service.modal.success("권한을 저장했습니다.");
            const selectedId = this.selectedMember.id;
            await this.load();
            this.selectedMember = this.members.find((item: any) => item.id === selectedId) || null;
            if (this.selectedMember) this.detailRole = this.selectedMember.role;
            await this.service.render();
        } else {
            await this.service.modal.error(data?.message || "권한 저장에 실패했습니다.");
        }
    }

    public async removeMember(member?: any) {
        const target = member || this.selectedMember;
        if (!target) return;

        let res = await this.service.modal.show({
            title: "사용자 제거",
            message: `${target.name}님을 사용자/권한 목록에서 제거하시겠습니까?`,
            action: "권한 제거",
            actionBtn: "error",
            status: "error"
        });
        if (!res) return;

        const { code, data } = await wiz.call("remove", { id: target.id });
        if (code === 200) {
            if (this.selectedMember?.id === target.id) this.selectedMember = null;
            await this.load();
        } else {
            await this.service.modal.error(data?.message || "사용자 제거에 실패했습니다.");
        }
    }

    public memberInitial(member: any) {
        return String(member?.name || member?.email || "?").charAt(0).toUpperCase();
    }

    public summaryCardClass(tone: string) {
        switch (tone) {
            case "admin": return "border-indigo-200 bg-indigo-50/70";
            case "manager": return "border-sky-200 bg-sky-50/70";
            case "reviewer": return "border-emerald-200 bg-emerald-50/70";
            case "risk": return "border-rose-200 bg-rose-50/70";
            default: return "border-gray-200 bg-white";
        }
    }

    public roleClass(role: string) {
        switch (role) {
            case "system":
            case "admin": return "border-indigo-200 bg-indigo-50 text-indigo-700";
            case "manager": return "border-sky-200 bg-sky-50 text-sky-700";
            case "reviewer": return "border-emerald-200 bg-emerald-50 text-emerald-700";
            case "viewer": return "border-gray-200 bg-gray-50 text-gray-600";
            default: return "border-gray-200 bg-gray-50 text-gray-600";
        }
    }

    public roleLabel(role: string) {
        switch (role) {
            case "system":
            case "admin": return "시스템관리자";
            case "manager": return "관리자";
            case "reviewer": return "검수자";
            case "viewer": return "조회자";
            default: return role || "-";
        }
    }

    public statusClass(status: string) {
        switch (status) {
            case "active": return "border-emerald-200 bg-emerald-50 text-emerald-700";
            case "inactive": return "border-gray-200 bg-gray-50 text-gray-600";
            case "locked": return "border-rose-200 bg-rose-50 text-rose-700";
            default: return "border-gray-200 bg-gray-50 text-gray-600";
        }
    }

    public statusLabel(status: string) {
        switch (status) {
            case "active": return "활성";
            case "inactive": return "비활성";
            case "locked": return "잠김";
            default: return status || "-";
        }
    }
}

export default PageMembersComponent;